import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SEARCH_TAGS } from 'js/constants/App';
import { useNavigate } from 'react-router-dom';
import { getLocale } from 'js/store/app/App.selectors';

// import components
import GridCardList from 'js/containers/grid/Grid.card-list';

// import Icons
import HeaderResults from 'js/components/header/Header.results';

// import selectors
import { getCardsInResults } from 'js/store/search/Search.selectors';
import { trackEvent } from '../../../utils/tracking';
import { getTranslationById } from 'js/store/app/App.selectors';

const FindResults = () => {
  const filters = useSelector((state) => state?.search?.filters);
  const cards = useSelector((state) => getCardsInResults(state));
  const locale = useSelector((state) => getLocale(state));
  const navigate = useNavigate();

  useEffect(() => {
    // rediect to find page if accessed externally
    !filters.activity && navigate('/find', { replace: true });
  }, []);

  useEffect(() => {
    const selectedPlayType = filters.playType[0] ?? '';
    const selectedPlayers = filters.players[0] ?? '';
    const selectedMinutes = filters.minutes[0] ?? '';

    trackEvent('game_find_search', {
      game_language: locale,
      category_name: filters.activity,
      location_name: filters.playType.join(','),
      player_count: filters.players.join(','),
      time_available: filters.minutes.join(','),
    });
  }, [filters, locale]);

  const siteText = {
    activity_1: useSelector((state) =>
      getTranslationById(state, 'find_step_1_time_to_transition', 'Time to Transition')
    ),
    activity_2: useSelector((state) => getTranslationById(state, 'find_step_1_lets_get_moving', "Let's Get Moving")),
    activity_3: useSelector((state) =>
      getTranslationById(state, 'find_step_1_calm_and_collected', 'Calm and Collected')
    ),
  };

  const selectedActivity = useSelector((state) => state?.search?.filters?.activity || 'activity_1');

  return (
    <>
      <HeaderResults title={siteText[selectedActivity]} />
      <GridCardList cards={cards} fromSearch={filters} />
    </>
  );
};

export default FindResults;
